import React from 'react';
import { IconHelp } from '@tabler/icons-react';

import { useTranslate, useWidgetsTheme as theme } from '@src/core/hooks';
import { Legend, LegendArea, LegendBox, LegendLabel, LegendLabelSuggestedPrice, TopArea } from './styles';
import { LayoutColors } from '@src/core/theme';

const CalendarLegend = () => {
  const { i18n } = useTranslate();

  return (
    <LegendArea>
      <TopArea>
        <Legend>
          <LegendLabel>{i18n('adder_legend_available')}</LegendLabel>
          <LegendBox bgColor={theme('successColor')} />
        </Legend>

        <Legend>
          <LegendLabel>{i18n('adder_legend_current')}</LegendLabel>
          <LegendBox borderColor={theme('selectionColor')} />
        </Legend>

        <Legend>
          <LegendLabel>{i18n('adder_legend_unavailable')}</LegendLabel>
          <LegendBox bgColor={theme('unavailableColor')} />
        </Legend>
      </TopArea>

      <Legend>
        <LegendLabelSuggestedPrice>{i18n('adder_legend_suggested_prices')}</LegendLabelSuggestedPrice>
        <IconHelp
          title={i18n('adder_legend_suggested_prices_tooltip')} // Replace this by Tooltip  from DS, when available
          style={{ cursor: 'pointer' }}
          size={24}
          color={LayoutColors.blackMain}
        />
      </Legend>
    </LegendArea>
  );
};

export default CalendarLegend;
